import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../../../global-components/global-components.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {SchoolPlansControllerComponent} from './school-plans-controller.component';
// import {FeatherModule} from 'angular-feather';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        SchoolPlansControllerComponent
    ],
    exports: [
      SchoolPlansControllerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        GlobalComponentsModule,
        SharedComponentsModule,
    ]
})
export class SchoolPlansModule {}
